<template>
    <div class="additem addcart" :class="{ 'inline pr-2' : btnStyle == 'style1' }">
        <div v-if="btnStyle == 'style2' " v-on:click="addToCart(product)" class="addcart ui icon button teal p-2 row align-items-center d-flex align-items-center">
            <i class="addcart icon-custom-add-cart large"></i>
            <span class="addcart ui text small-sm mini light pt-1 ml-1">{{$t('AddCart')}}</span>
        </div>
        <div v-if="btnStyle == 'style1' " v-on:click="addToCart(product)" class="btn-anime ui button circular theme icon d-inline-block p-2 m-0">
            <i class="icon-custom-add-cart large d-block"></i>
            <div class="anime-cart">
                <span class="s1"></span>
                <span class="s2"></span>
                <span class="s3"></span>
                <span class="s4"></span>
                <span class="s5"></span>
                <span class="s6"></span>
                <span class="s7"></span>
                <span class="s8"></span>
            </div>
        </div>
        <div v-if="btnStyle == 'style3' " v-on:click="addToCart(product)" class="ui button theme teal text large col-12 p-md-2 shadow p-2 col-12">
            <i class="icon-custom-add-cart" style="font-size:1.6rem"></i> &nbsp;
            <span class="ui text big-lg medium-md medium">{{$t('AddCart')}}</span>
        </div>
        <div v-if="btnStyle == 'style4' " v-on:click="addToCart(product)" class="ui button theme teal text large col-12 p-md-2 shadow p-2 col-12">
            <i class="icon-custom-add-cart" style="font-size:1.6rem"></i> &nbsp;
            <span class="ui text big-lg medium-md medium">{{$t('AddCart')}}</span>
        </div>
        <button v-if="btnStyle == 'style5' " v-on:click="addToCart(product)" class="ui button text large theme col-12 p-md-2 shadow p-2 col-12">
            <span class="ui text big-lg medium-md medium">{{$t('ByNow')}}</span>
        </button>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import _ from "lodash";
export default {
    name: 'additem',
    components: {},
    props: {
        product: Object,
        btnStyle: String,
        goCart: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {}
    },
    computed: mapState(["cartProducts"]),
    created () {
    },
    mounted(){
        $('.btn-anime').on('click',function(){
            $(this).addClass('show-anime')
            setTimeout(function() {
                $('.btn-anime').removeClass("show-anime")
            }, 350); 
        }) 
    },
    methods: {
        ...mapMutations(["ADD_CART_LOCAL","EDIT_CART_LOCAL"]),
        addToCart(product) {
            this.$http
            .get('products/' + product.id)
            .then(response => {
                let item = response.data.data
                if(item.quantity == 0){
                    let message = {
                        message: this.$t('OutStock'),
                        title: this.$t('ShoppingCart')
                    }
                    this.$parent.$parent.message = message
                    this.$parent.$parent.$parent.message = message
                    this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
                    this.$parent.$parent.$parent.showMessage = !this.$parent.$parent.$parent.showMessage
                    return
                }
                let newProduct = {
                    id : item.id,
                    image : (item.images[0]) ? item.images[0].url : null,
                    name: item.titleTH,
                    amount: 1,
                    quantity: item.quantity,
                }
                if(item.skus.length){
                    let sku1Id = null
                    let sku2Id = null
                    if(product.selected && product.selected.selectSku1 != null ){
                        sku1Id = product.selected.selectSku1
                        sku2Id = product.selected.selectSku2
                    }else{
                        sku1Id = (item.skuOptions[0])? item.skuOptions[0].skus[0].id : null
                        sku2Id = (item.skuOptions[1])? item.skuOptions[1].skus[0].id : null
                    }
                    let data = _.find(item.skus, {'sku1Id' : sku1Id,'sku2Id' : sku2Id});
                    if (data) {
                        newProduct.quantity = data.quantity
                        newProduct.sku = data
                        newProduct.price = data.price
                        newProduct.netPrice = data.netPrice
                    }else{
                        console.log(product.selected)
                        return
                    }
                }else{
                    newProduct.sku = null
                    newProduct.price = item.price
                    newProduct.netPrice = item.netPrice
                }
                if(product.amount && newProduct.quantity >= product.amount){
                    newProduct.amount = product.amount
                }
                let update = false
                _.filter(this.cartProducts, findItem => {
                    if(findItem.id == newProduct.id ){
                        if( ( newProduct.sku != null && findItem.sku.id == newProduct.sku.id ) || (newProduct.sku == null && item.skus.length == 0)  ) { 
                            newProduct.amount = ((findItem.amount + newProduct.amount) < newProduct.quantity)? findItem.amount + newProduct.amount : newProduct.quantity
                            newProduct.itemId = findItem.itemId
                            this.EDIT_CART_LOCAL(newProduct)
                            update = true
                            return
                        }
                    }
                })
                if(!update){
                    newProduct.itemId = Date.now(),
                    this.ADD_CART_LOCAL(newProduct)
                }
                if(this.goCart == true){
                    this.$router.push('/cart')
                }
            })
            .catch(error => console.log(error))
        },
    }
}
</script>

<style lang="scss" scoped>
    .additem.inline{
        display: inline-block;
    }
    .additem{
        position: relative;
        .circular{
            padding: 0 !important;
            width: 35px;
            z-index: 300;
            height: 35px;
            i{
                z-index: 300;
                position: relative;
                margin-top: 6px;
            }
        }
    }
     .anime-cart{
        z-index: 200;
        position: absolute;
        top: 0%;
        left: 0%;
        width: 35px;
        height: 35px;
        span{
            position: absolute;
            top: 50%;
            left: 50%;
            opacity: 0;
        }
        span::before{
            position: absolute;
            content: '';
            border: 3px solid red; 
            top: -3px;
            left: -3px;
            width: 2px;
            border-radius: 10px;
        }
    }
    .show-anime .anime-cart{
        span{
            transition: all 0.35s ease-in-out;   
             animation: myshow .35s ease-in;
        }
        .s1{
            top: -50%;
        }
        .s2{
            top: 150%;
        }
        .s3{
            left: -50%;
        }
        .s4{
            left: 150%;
        }
        .s5{
            left: -25%;
            top: -25%;
        }
        .s6{
            left: -25%;
            top: 125%;
        }
        .s7{
            left: 125%;
            top: 125%;
        }
        .s8{
            top: -25%;
            left: 125%;
        }
    }
    @keyframes myshow {
        0% {opacity: 0;}
        60% {opacity: 1;}
        100% {opacity: 0;}
    }
</style>